const buildYachtInfo = ({ name, builtOnYear, lengthOverall, parsedEntity }) => {
  const year = builtOnYear || '';
  const length = lengthOverall ? `${lengthOverall}m` : '';
  const separator = year && length ? ', ' : '';
  const parsedYearAndLength = !year && !length ? '' : ` (${year}${separator}${length})`;
  return `${name}${parsedYearAndLength} - ${parsedEntity}`;
};

export default buildYachtInfo;
